import { render, staticRenderFns } from "./OtherPage.vue?vue&type=template&id=cf5af5d6&scoped=true"
import script from "./OtherPage.vue?vue&type=script&lang=js"
export * from "./OtherPage.vue?vue&type=script&lang=js"
import style0 from "./OtherPage.vue?vue&type=style&index=0&id=cf5af5d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5af5d6",
  null
  
)

export default component.exports